import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';

export const GET_PROMOCODE_REQUEST = 'GET_PROMOCODE_REQUEST';
export const GET_PROMOCODE_RESPONSE = 'GET_PROMOCODE_RESPONSE';
export const GET_PROMOCODE_ERROR = 'GET_PROMOCODE_ERROR';

export const GET_PCR_CLINICS_REQUEST = 'GET_PCR_CLINICS_REQUEST';
export const GET_PCR_CLINICS_RESPONSE = 'GET_PCR_CLINICS_RESPONSE';
export const GET_PCR_CLINICS_ERROR = 'GET_PCR_CLINICS_ERROR';

export const CLEAR_PROMOCODE = 'CLEAR_PROMOCODE';

const PROMOCODES_HOST = process.env.REACT_APP_PROMOCODES_HOST;
const PROMOCODES_KEY = process.env.REACT_APP_PROMOCODES_KEY;

export const getPromocodesAction = (typeKey: string, userId: string, preferredClinic?: number[], clientAddress?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PROMOCODE_REQUEST,
        typeKey,
        userId
    });

    const clinicsStr = preferredClinic ? preferredClinic!.join('&preferred_clinic[]=') : '';

    try {
        const response = await fetcher(`${PROMOCODES_HOST}/api/v1/promocodes/${typeKey}/${userId}${clinicsStr ? `?preferred_clinic[]=${clinicsStr}&client_address=${clientAddress}` : ''}`)
            .auth(`Basic ${PROMOCODES_KEY}`)
            .json();

        dispatch({
            type: GET_PROMOCODE_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_PROMOCODE_ERROR,
            error
        });
    }
};

export const getPcrClinicsAction = (lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PCR_CLINICS_REQUEST
    });

    try {
        const response = await fetcher(`${PROMOCODES_HOST}/api/v1/pcr_clinics?lang=${lang}`)
            .auth(`Basic ${PROMOCODES_KEY}`)
            .json();

        dispatch({
            type: GET_PCR_CLINICS_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_PCR_CLINICS_ERROR,
            error
        });
    }
};

export const clearPromocodeAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLEAR_PROMOCODE
    });
};



// WEBPACK FOOTER //
// ./src/actions/Promocodes/promocodes.ts